import { InteractionLike } from "@/services/DTOs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OpportunitiesApiService } from "./OpportunitiesApiService";

class Service {
  public addInteraction(interaction: InteractionLike): Observable<string> {
    const url = "/api/suite/messenger/activities";

    return OpportunitiesApiService.post(url, interaction).pipe(
      map((response) => response.data.id));
  }
}

export const InteractionsService = new Service();
